import React from 'react';
import './CookieReopenButton.css';

function CookieReopenButton({ visible, onClick }) {
  return (
    <button
      type="button"
      className={`cookie-reopen ${visible ? 'is-visible' : ''}`}
      aria-label="Gestisci preferenze cookie"
      title="Gestisci preferenze cookie"
      onClick={onClick}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" />
        <circle cx="8.5" cy="8.5" r="1" fill="currentColor" />
        <circle cx="12" cy="14" r="1" fill="currentColor" />
        <circle cx="16" cy="10" r="1" fill="currentColor" />
      </svg>
    </button>
  );
}

export default CookieReopenButton;
